import { forwardRef, useMemo } from 'react';
import {
  Animated,
  FlatListProps,
  ImageResizeMode,
  ViewToken,
} from 'react-native';

import FlatListWithImpression from '../../components/FlatListWithImpression';
import { ImpressionDataProps } from '../../components/FlatListWithImpression/types';
import { Impression } from '../../types/CTR';
import Cover from './Cover';
import { CoverSourceType } from './types';
import { useCoverProps } from './utils';

interface Props extends FlatListProps<any>, ImpressionDataProps {
  coverHeight: number;
  style?: any;
  coverSource?: CoverSourceType;
  coverResizeMode?: ImageResizeMode;
  bgColor?: string;
  showPlaceholder?: boolean;
  testID?: string;
  withImpression?: boolean;
  onCoverLoadEnd?: () => void;
  dataProducer?: (data: ViewToken, props: ImpressionDataProps) => Impression[];
}

export default forwardRef((props: Props, ref) => {
  const {
    coverSource,
    coverHeight,
    coverResizeMode,
    bgColor,
    showPlaceholder,
    withImpression,
    onScroll,
    onCoverLoadEnd,
    ...others
  } = props;

  const { handleOnScroll, style: coverStyle } = useCoverProps(
    coverHeight,
    onScroll
  );

  const FlatListComponent = useMemo(() => {
    if (withImpression) {
      return FlatListWithImpression;
    }

    return Animated.FlatList;
  }, [withImpression]);

  return (
    <>
      <Cover
        style={coverStyle}
        coverSource={coverSource}
        coverHeight={coverHeight}
        coverResizeMode={coverResizeMode}
        bgColor={bgColor}
        showPlaceholder={showPlaceholder}
        onLoadEnd={onCoverLoadEnd}
      />
      <FlatListComponent
        {...others}
        onScroll={handleOnScroll}
        ref={ref}
        animated
      />
    </>
  );
});
